import { StatCard, StatCardRow } from '@/components/ui/StatCard';

import { State } from '../State';

export function StatCardExamples() {
  return (
    <>
      <State title="Four across, with every kind of change line">
        <StatCardRow label="Sample summary, four across">
          <StatCard
            label="Supporters"
            value="4,631"
            change={{ percent: 6.4, direction: 'up' }}
            caption="People following the organization"
          />
          <StatCard
            label="Notifications sent"
            value="12"
            change={{ percent: -3.1, direction: 'down' }}
          />
          <StatCard
            label="Active campaigns"
            value="3"
            change={{ percent: 0, direction: 'flat' }}
          />
          <StatCard label="Surveys open" value="1" caption="No change line at all" />
        </StatCardRow>
      </State>

      <State title="No previous period" note="A change with nothing to compare against.">
        <StatCardRow label="Sample summary, first period">
          <StatCard
            label="Supporters"
            value="4,631"
            change={{ percent: null, direction: 'flat' }}
          />
        </StatCardRow>
      </State>

      <State title="Loading" note="Placeholders the size of what replaces them.">
        <StatCardRow label="Sample summary, loading">
          <StatCard
            label="Supporters"
            value=""
            loading
            change={{ percent: 0, direction: 'flat' }}
          />
          <StatCard label="Notifications sent" value="" loading />
        </StatCardRow>
      </State>

      <State
        title="Three across"
        note="Six cards then make two full rows, not four and two orphans."
      >
        <StatCardRow label="Sample summary, three across" columns={3}>
          <StatCard label="Delivered" value="1,204" />
          <StatCard label="Opened" value="611" />
          <StatCard label="Acted" value="88" />
          <StatCard label="Shared" value="42" />
          <StatCard label="Replied" value="17" />
          <StatCard label="Unsubscribed" value="3" />
        </StatCardRow>
      </State>
    </>
  );
}
